import { makeStyles } from 'tss-react/mui';

import { MAX_HEIGHT, MIN_HEIGHT } from './BDBottomSheet.constants';

const useStyles = makeStyles()((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer,
  },
  container: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: theme.new.color.common.white,
    borderTopLeftRadius: theme.spacing(2),
    borderTopRightRadius: theme.spacing(2),
    boxShadow: theme.new.boxShadows.elevation1,
    display: 'flex',
    flexDirection: 'column',
    transition: 'height 0.2s ease-out',
    maxHeight: `${MAX_HEIGHT * 100}vh`,
    minHeight: `${MIN_HEIGHT * 100}vh`,
    overflow: 'hidden',
  },
  containerDragging: {
    transition: 'none',
  },
  handle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: `${theme.new.spacing.small} 0 ${theme.new.spacing.medium}`,
    cursor: 'grab',
    touchAction: 'none',
    flexShrink: 0,
    '&:active': {
      cursor: 'grabbing',
    },
  },
  handleBar: {
    width: '80px',
    height: '4px',
    backgroundColor: theme.new.color.grey[400],
    borderRadius: theme.spacing(0.5),
  },
  content: {
    flex: 1,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
}));

export default useStyles;
